<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Administradores"></no-habilitado>
    <app-error v-if="error" :errorMensaje="errorMensaje"></app-error>
    <h1 style="margin-top:100px; margin-left:50px">Administrar Niveles</h1>
    <section
      v-if="(niveles.length>0)"
      style=" background-color: #ececec; padding-top: 50px; padding-bottom: 30px; margin-left: 20px; margin-right: 20px;"
    >
      <h3 v-if="userLogged.profile != 'ADMINISTRADOR'">Niveles</h3>

      <div class="container">
        <div class="row" style="justify-content: center">
          <div v-for="(nivel,index) in niveles" :nivel="nivel" v-bind:key="index">
            <div class="card categoria">
              <div class="card-body">
                <h3 class="texto-car-categoria">{{ nivel.nombre_nivel }}</h3>
                <h5
                  class="texto-car-categoria"
                >de {{ nivel.puntaje_minimo }} a {{ nivel.puntaje_maximo }}</h5>
                <a href="#" @click="seleccionarNivel(nivel)" style="padding-right:10px">Modificar</a>
                <a href="#" @click="eliminarModal(nivel)">Eliminar</a>
              </div>
            </div>
          </div>
          <div class="card categoria" style="text-align:center" @click="modalNivel()">
            <div class="card-body">
              <h4 class="texto-car-categoria">Nuevo nivel</h4>
              <img
                src="public/images/arkidians/nuevo.svg"
                width="50px"
                alt="Arkidia"
                style="border-radius:100%; background-color:#007bff"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal
      ref="modificar-modal"
      hide-footer
      :title="'Modificar nivel ' + nivelSeleccionado.nombre_nivel"
    >
      <div class="d-block">
        <div class="form-group">
          <label>Puntaje Máximo</label>
          <input class="form-control" v-model="nivelSeleccionado.puntaje_maximo" />
        </div>

        <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
      </div>
      <b-button
        class="mt-3"
        variant="primary"
        block
        @click="modificarNivel(nivelSeleccionado)"
      >Modificar</b-button>
    </b-modal>

    <b-modal ref="nuevo-modal" hide-footer title="Nuevo nivel">
      <div class="d-block">
        <div class="form-group">
          <label>Nombre del nivel</label>
          <input class="form-control" v-model="nuevoNivel.nombre_nivel" />
        </div>
        <div class="form-group">
          <label>Puntaje máximo</label>
          <input class="form-control" v-model="nuevoNivel.puntaje_maximo" />
        </div>

        <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
      </div>
      <b-button
        class="mt-3"
        variant="primary"
        block
        @click="crearNivel(nuevoNivel)"
      >Crear nuevo nivel</b-button>
    </b-modal>

    <b-modal ref="eliminar-modal" hide-footer title="Eliminar Nivel">
      <div class="d-block text-center">
        <h5>¿Estás seguro que querés eliminar el nivel {{nivelSeleccionado.nombre_nivel}}?</h5>
      </div>
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="eliminarNivel(nivelSeleccionado)"
      >Eliminar</b-button>
      <b-button class="mt-2" variant="warning" block @click="cerrarEliminar">Cerrar</b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";
import appError from "../shared/Error";

export default {
  name: "app",
  data() {
    return {
      habilitado: false,
      error: false,
      nivelSeleccionado: {},
      nuevoNivel: {},
      errorMessage: "",
      niveles: []
    };
  },
  methods: {
    buscarNiveles() {
      fetch(this.pathAPI + "niveles.php?usuario=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          this.niveles = data.sort(this.compare);
          for (var i = 0; i < this.niveles.length; i++) {
            if (i == 0) {
              this.niveles[0].puntaje_minimo = 1;
            } else {
              this.niveles[i].puntaje_minimo =
                parseInt(this.niveles[i - 1].puntaje_maximo) + 1;
            }
          }
        });
    },
    compare(a, b) {
      const puntajeA = parseInt(a.puntaje_maximo);
      const puntajeB = parseInt(b.puntaje_maximo);

      let comparison = 0;
      if (puntajeA > puntajeB) {
        comparison = 1;
      } else if (puntajeA < puntajeB) {
        comparison = -1;
      }
      return comparison;
    },
    seleccionarNivel(nivel) {
      this.nivelSeleccionado = nivel;
      this.$refs["modificar-modal"].show();
    },
    modalNivel() {
      this.nuevoNivel = {};
      this.$refs["nuevo-modal"].show();
    },
    crearNivel(nivel) {
      var bodyApi;
      bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&nombre_nivel=" +
        nivel.nombre_nivel +
        "&puntaje_maximo=" +
        nivel.puntaje_maximo;
      fetch(this.pathAPI + "niveles.php?", {
        method: "POST",
        body: bodyApi,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(response => response.json())
        .then(data => {
          this.buscarNiveles();

          this.$refs["nuevo-modal"].hide();
        });
    },
    modificarNivel(nivel) {
      var bodyApi;
      (bodyApi =
        "usuario=" +
        this.userLogged.user +
        "&nombre_nivel=" +
        nivel.nombre_nivel +
        "&puntaje_maximo=" +
        nivel.puntaje_maximo),
        fetch(this.pathAPI + "niveles.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        })
          .then(() => {
            this.buscarNiveles();

            this.$refs["modificar-modal"].hide();
          })
          .catch(() => {
            console.log("error");
          });
    },
    eliminarModal(nivel) {
      this.nivelSeleccionado = nivel;
      this.$refs["eliminar-modal"].show();
    },
    cerrarEliminar() {
      this.$refs["eliminar-modal"].hide();
    },
    eliminarNivel(nivel) {
      fetch(
        this.pathAPI +
          "niveles.php?nombre_nivel=" +
          nivel.nombre_nivel +
          "&usuario=" +
          this.userLogged.user,
        {
          method: "DELETE"
        }
      ).then(() => {
        this.niveles = [];
        this.buscarNiveles();
        this.$refs["eliminar-modal"].hide();
      });
    }
  },
  computed: {
    ...mapGetters(["userLogged", "pathAPI"])
  },
  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    appError: appError
  },

  mounted: function() {
    if (this.userLogged.profile == "ADMINISTRADOR") {
      this.buscarNiveles();
      this.habilitado = true;
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/admin/AdminNivel.vue